import { _ as u } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { c as e, e as o, g as r, j as c, i as l, F as p, p as i } from "./define-element-XpjsV6s1.js";
const f = {
  class: "offset-loader-product",
  role: "status"
}, m = { class: "offset-loader-product-sr-text" }, _ = {
  __name: "LoaderProduct",
  props: {
    count: {
      type: Number,
      default: 1
    }
  },
  setup(s) {
    const a = s;
    return (d, t) => (e(), o("div", f, [
      r("span", m, [
        c(d.$slots, "default", {}, () => [
          t[0] || (t[0] = l("Loading products…", -1))
        ], !0)
      ]),
      (e(!0), o(p, null, i(a.count, (n) => (e(), o("div", {
        key: n,
        class: "offset-loader-product-item",
        "aria-hidden": "true"
      }, t[1] || (t[1] = [
        r("div", null, " ", -1),
        r("div", null, " ", -1)
      ])))), 128))
    ]));
  }
}, x = /* @__PURE__ */ u(_, [["__scopeId", "data-v-c63acbd3"]]);
export {
  x as L
};
